import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
});



/* ----------------------------------
　humberger menu
---------------------------------- */
window.addEventListener('load', () => {
  let navEle = document.querySelector('.hd_menu-toggle');
  let navWrap = document.querySelector('.hd_nav');
  let navBg = document.querySelector('.hd_nav_bg'); // ← 追加

  // メニューボタン（.hd_menu-toggle）をクリックした時の動作
  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    navWrap.classList.toggle('is_open', !isOpen);
    navEle.classList.toggle('is_open', !isOpen);
    navBg.classList.toggle('is_open', !isOpen); // ← 追加
  });
});


/* ----------------------------------
 Swiper
---------------------------------- */
$(function() {
    const swiper = new Swiper('.index_slider', {
      // Optional parameters
      loop: true,
      slidesPerView: 3.5,
      spaceBetween: 5,
      navigation: {
        nextEl: ".index_works_btn-next_wrapper",
        prevEl: ".index_works_btn-prev_wrapper",
      },
      breakpoints: {
      // スライドの表示枚数：1024px以上の場合
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      // スライドの表示枚数：300px以上の場合
      500: {
        slidesPerView: 2,
        spaceBetween: 13,
      },
      // スライドの表示枚数：300px以上の場合
      300: {
        slidesPerView: 1,
        spaceBetween: 10,
      }
    }
  
  });
});






/* ----------------------------------
　ヘッダー出現
---------------------------------- */
window.addEventListener('scroll', function () {
  const header = document.querySelector('.header');
  const lowMv = document.querySelector('.low_mv');
  const mainImg = document.querySelector('.index_mainimg_wrap');

  if (!header) return;

  const lowMvBottom = lowMv ? lowMv.offsetTop + lowMv.offsetHeight : 0;
  const mainImgBottom = mainImg ? mainImg.offsetTop + mainImg.offsetHeight : 0;
  const triggerPoint = Math.max(lowMvBottom, mainImgBottom);

  const scrollY = window.scrollY || window.pageYOffset;

  if (scrollY > triggerPoint) {
    header.classList.add('is_fixed');
  } else {
    header.classList.remove('is_fixed');
  }
});



/* ----------------------------------
 HOMEのMV　スライドショー
---------------------------------- */
  const swiper = new Swiper(".swiper-fade", {
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 1500,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

/* ----------------------------------
　サイドバー追従
---------------------------------- */
window.addEventListener('scroll', function () {
  // 1024px以下なら処理しない（ここがポイント！）
  if (window.innerWidth <= 1024) return;

  const sideBar = document.querySelector('.company_side-bar');
  const lowMv = document.querySelector('.low_mv');
  const companyArea = document.querySelector('.company_area');

  if (!sideBar || !lowMv || !companyArea) return;

  const scrollY = window.scrollY || window.pageYOffset;
  const lowMvBottom = lowMv.offsetTop + lowMv.offsetHeight;
  const companyAreaBottom = companyArea.offsetTop + companyArea.offsetHeight;
  const sideBarHeight = sideBar.offsetHeight;

  const margin = 100;
  const sideBarBottomPosition = scrollY + sideBarHeight + margin;

  if (scrollY > lowMvBottom && sideBarBottomPosition < companyAreaBottom) {
    sideBar.classList.add('is_fixed');
    sideBar.classList.remove('is_bottom');
  } else if (sideBarBottomPosition >= companyAreaBottom) {
    sideBar.classList.remove('is_fixed');
    sideBar.classList.add('is_bottom');
  } else {
    sideBar.classList.remove('is_fixed');
    sideBar.classList.remove('is_bottom');
  }
});




/* ----------------------------------
　沿革
---------------------------------- */
window.addEventListener('load', () => {
  adjustLines();
  animateDotsOnScroll();
});
window.addEventListener('resize', adjustLines);

function adjustLines() {
  const boxes = document.querySelectorAll('.company_history_box');

  boxes.forEach((box, index) => {
    const dot = box.querySelector('.dot');
    const content = box.querySelector('.company_history_content');
    const nextBox = boxes[index + 1];
    const nextContent = nextBox?.querySelector('.company_history_content');

    const thisHalf = content.offsetHeight / 2;
    const nextHalf = nextContent ? nextContent.offsetHeight / 2 : 0;
    const lineHeight = thisHalf + nextHalf;

    dot.style.setProperty('--line-height', `${lineHeight}px`);
  });
}

function animateDotsOnScroll() {
  const dots = document.querySelectorAll('.dot');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is_visible');
      }
    });
  }, {
    threshold: 0.5
  });

  dots.forEach(dot => {
    observer.observe(dot);
  });
}




/* ----------------------------------
  スムーススクロール
---------------------------------- */
$(function () {
  function getHeaderHeight(isPageLoad) {
    // ページ読み込み時（#がある場合）とそれ以外でヘッダー高さを変更
    if (isPageLoad) {
      // ページ読み込み時（#がある場合）は、異なる高さを設定
      return window.innerWidth <= 768 ? 30 : 200;  // スマホの場合の高さ調整
    } else {
      // それ以外の場合（クリック時）は通常のヘッダー高さ
      return window.innerWidth <= 768 ? 30 : $('.is_fixed').outerHeight() || 200;
    }
    
  }

  // ページ内リンクをクリックしたとき：アニメーション付き
  $('a[href*="#"]').click(function () {
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname
    ) {
      const hash = this.hash;
      const $target = $(hash);
      if ($target.length) {
        const position = $target.offset().top - getHeaderHeight(false);
        $("html, body").animate({ scrollTop: position }, 600, "swing");
        return false;
      }
    }
  });

  // ページ読み込み時：アニメーションなしで即移動
  if (location.hash) {
    const $target = $(location.hash);
    if ($target.length) {
      const position = $target.offset().top - getHeaderHeight(true);
      $(window).scrollTop(position); // ← アニメーションなしで即スクロール
    }
  }
});



/*----------------------------------------
contact MWWP Form お問い合わせページ、確認画面のアンカー設定
------------------------------------------*/
window.addEventListener('load', () => {
  const header = document.querySelector(".header");
  const headerHeight = header ? header.offsetHeight : 0;

  if (document.querySelector('.contact_form_wrap')) {
    const selectEle = document.querySelector("select");

    if (selectEle) {
      selectEle.outerHTML = `<div class="select_wrap">${selectEle.outerHTML}</div>`;
    }

    topValidation?.(); // 関数があれば実行
  }

  const formElement = document.querySelector('.contact_mail_sec');
  const confirmEle = document.querySelector('.contact_confirm');
  const completeEle = document.querySelector('.contact_block');
  const returnBtn = document.querySelector('.contact-return_btn');

  // 各ページ状態でハッシュ追加
  if (confirmEle || completeEle) {
    location.hash = '#scroll';
  }

  // ボタンがある場合のみイベント設定
  if (returnBtn) {
    returnBtn.addEventListener('click', function () {
      location.hash = '#scroll';
    });
  }

  // フォーム位置へスクロール
  if (formElement && location.hash === '#scroll') {
    const posy = formElement.offsetTop - headerHeight;
    window.scrollTo({
      top: posy,
      behavior: 'smooth'
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const headerHeight = header ? header.offsetHeight : 0;

  if (document.querySelector('.contact_form_wrap')) {
    const errorElement = document.querySelector('.error');
    if (errorElement) {
      const form = document.querySelector('.mw_wp_form');
      if (form) {
        form.classList.add('mw_wp_form_error');
      }

      const position = errorElement.parentElement.offsetTop - headerHeight;
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    }
  }
});



/* ----------------------------------
  業務内容　流れ　コンテンツの高さを出力
---------------------------------- */
function adjustFlowItems() {
  const flowItems = document.querySelectorAll('.service_flow_item');

  flowItems.forEach(item => {
    const icon = item.querySelector('.service_flow_icon');
    const content = item.querySelector('.service_flow_content');

    if (icon && content) {
      const iconHeight = icon.offsetHeight;
      const contentHeight = content.offsetHeight;
      const maxHeight = Math.max(iconHeight, contentHeight);

      // 高さ揃える
      item.style.height = maxHeight + 'px';

      // 縦線の高さをcontentに合わせる（または maxHeight でもOK）
      item.style.setProperty('--line-height', `${contentHeight}px`);
    }
  });
}

window.addEventListener('load', adjustFlowItems);
window.addEventListener('resize', adjustFlowItems);






/* ----------------------------------
  施工事例　スライダー
---------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  const swiperBlocks = document.querySelectorAll('.swiper-thumb-wrap');

  swiperBlocks.forEach((block, index) => {
    const mainSwiperEl = block.closest('.works_swiper_wrap').querySelector('.swiper-main');
    const thumbSwiperEl = block.querySelector('.swiper-thumb');
    const prevBtn = block.querySelector('.swiper-button-prev');
    const nextBtn = block.querySelector('.swiper-button-next');

    // 一意なクラス名を付与
    const mainClass = 'js-main-' + index;
    const thumbClass = 'js-thumb-' + index;
    const prevClass = 'js-prev-' + index;
    const nextClass = 'js-next-' + index;

    mainSwiperEl.classList.add(mainClass);
    thumbSwiperEl.classList.add(thumbClass);
    prevBtn.classList.add(prevClass);
    nextBtn.classList.add(nextClass);

    // サムネイルスライダーを初期化
    const thumbSwiper = new Swiper(`.${thumbClass}`, {
      spaceBetween: 10,
      slidesPerView: 3,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      loop: false,
      navigation: {
        nextEl: `.${nextClass}`,
        prevEl: `.${prevClass}`,
      },
    });

    // メインスライダーを初期化
    const mainSwiper = new Swiper(`.${mainClass}`, {
      spaceBetween: 10,
      loop: false, // ←重要！これが true だと「常にループ＝ボタン無効が意味なくなる」
      navigation: {
        nextEl: `.${nextClass}`,
        prevEl: `.${prevClass}`,
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });

    // 最初と最後でボタンを切り替える
    function updateButtons(swiper) {
      if (swiper.isBeginning) {
        prevBtn.classList.add('swiper-button-disabled');
      } else {
        prevBtn.classList.remove('swiper-button-disabled');
      }

      if (swiper.isEnd) {
        nextBtn.classList.add('swiper-button-disabled');
      } else {
        nextBtn.classList.remove('swiper-button-disabled');
      }
    }

    // 初期状態ボタンを反映
    mainSwiper.on('init', () => {
      updateButtons(mainSwiper);
    });

    // スライドの移動時にも状態を更新
    mainSwiper.on('slideChange', () => {
      updateButtons(mainSwiper);
    });

    // Swiperが手動で `loop: false` の場合は init() 明示的に呼ぶ必要あり
    mainSwiper.init();
  });
});



//フェードイン
window.addEventListener("load", () => {
  setTimeout(() => {
    const fadeEls = document.querySelectorAll(".fade-in");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // 一度だけ表示したいなら
        }
      });
    }, {
      threshold: 0.1
    });

    fadeEls.forEach(el => observer.observe(el));
  }, 1800); // ← 3秒（3000ミリ秒）後に発火
});





/* ----------------------------------
  MV サブキャッチコピー
---------------------------------- */

function animateCatchcopy() {
  const target = document.querySelector(".index_catchcopy_sub");

  if (!target || target.classList.contains('inview')) return;

  const text = target.textContent.trim();
  target.textContent = "";

  [...text].forEach((char, index) => {
    const span = document.createElement("span");
    span.textContent = char;
    span.classList.add("char");
    span.style.transitionDelay = `${index * 0.05}s`;
    target.appendChild(span);
  });

  // 2秒後にクラス追加でアニメーション開始
  setTimeout(() => {
    target.classList.add("inview");
  }, 500);
}

// .index_catchcopy_top のクラス変化を監視
const topEl = document.querySelector(".index_catchcopy_top");
if (topEl) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target.classList.contains("active")
      ) {
        animateCatchcopy();
        observer.disconnect(); // 一度だけなら
      }
    }
  });

  observer.observe(topEl, { attributes: true });
}